<template>
  <div>
    <v-row>
      <v-col cols="12">
        <promo-status />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PromoStatus from 'Components/Promo/view/PromoStatus'

export default {
  name: 'PromoStatusView',
  components: {
    PromoStatus
  }
}
</script>
